export interface SignState {
    value: number;
    label: string;
}

export enum SIGN_STATUS {
    NOT_SIGNED = 0, // 0-待签约
    SIGNING = 1, // 1-签约中
    SIGNED = 2, // 2-已签约
    EXPIRED = 3, // 3-合作到期
    END = 4, // 4-合作终止
    FAILED_SIGN = 5, // 5-签约失败
}

export enum SOURCE_TYPE {
    ALL = 0, // 0 全部
    OFFICIAL = 1, // 1 官方代运营
    SERVICE = 2, // 服务市场业务
    SELF = 3, // 品牌分账
    C_PLUS = 4, // C+代运营业务
}

export enum CONTRACT_TYPE {
    // 未签约
    All = 0,
    // 1-官方代运营扶持期原有合同
    FOSTER = 1,
    // 按效计费代运营合同
    RENEWAL = 2,
    // 官方代运营扶持期新店模式
    FOSTER_NEW_SHOP = 3,
    // 官方代运营扶持期老店模式
    FOSTER_OLD_SHOP = 4,
    // 官方代运营售卖场景新店模式
    OFFICIAL_SELL_NEW_SHOP = 5,
    // 官方代运营售卖场景老店模式
    OFFICIAL_SELL_OLD_SHOP = 6,
    // 直播全款模式
    LIVE_ALL = 12,
    // 代运营按效托管模式
    EFFECT_HOSTING = 13,
    // 直播cps抽佣模式
    LIVE_CPS = 14,
    // C+按效付费
    C_PLUS = 16,
    // 官方代运营按效计费模式
    EFFECT_OFFICIAL = 17,
}
/**
 * 分配类型 -1-所有  0-手动分配 1-新店自动分配
 */
export enum DistributeSource {
    ALL = -1,
    OLD = 0,
    NEWPOI = 1,
}

interface contractItem {
    contractName: string;
    signTime: number;
    pdfUrl: string;
}

/**
 * 是否签过扶植期合同
 */
enum THIRD_SIGN {
    noSign = 0,
    Signed = 1,
}

export enum HAS_EXPIRE {
    notExpire = 0,
    expired = 1,
}

export interface SignItem {
    id: string;
    distributeTime: number;
    wmPoiId: number;
    poiName: string;
    phone: string;
    linkman: string;
    cityName: string;
    providerId: number;
    simpleProviderName: string;
    status: SIGN_STATUS;
    noPartnerReason: string;
    contractName: string;
    settleRule: string;
    startTime: number;
    endTime: number;
    hasExpire: HAS_EXPIRE;
    thirdSign?: THIRD_SIGN;
    contractList?: contractItem[];
    customerSource: SOURCE_TYPE;
    distributeSource: DistributeSource;
    coopMode: CONTRACT_TYPE;
    // settlementRuleDescList: string[];
    /** 商家结算规则 */
    poiSettlementRuleDescList: string[];
    /** 服务商结算规则 */
    providerSettlementRuleDescList: string[];
}

export interface IncrementFeeItem {
    // order: number;
    ladderThreshold: number | string;
    ladderCommissionRate: number | string;
}

export interface SettlementRule {
    incrCommissionRate?: string;
    gvmIncrRate?: string;
    gvmIncrMin?: number;
    baseFee?: number;
    topCharge?: number;
    incrementFee?: string;
    earningsThreshold?: number;
    /** 参数台阶 (分->元) */
    paramStep?: number;
    /** 激励封顶金额（分->元） */
    subsidyTopAmount?: number;
    /** 增量返款比例（小数点->%） */
    incrRebateRate?: number;
    /** 全量返款比例（小数点->%）*/
    fullRebateRate?: number;
    /** 合作不满60天商家推广现金消耗基准（分->元） */
    expendStandard?: number;
}

// 计费周期
export enum FORM_TIP {
    /** 按日计费 */
    PERIOD_D = 'PERIOD_D',
    /** 按月计费 */
    PERIOD_M = 'PERIOD_M',
}
export interface ICooperateItem {
    value: string;
    label: string;
}
export type ICooperateList = ICooperateItem[];

export interface IGetSettlementRuleByPeriodReq {
    distributeId: number;
    period: number;
}
export interface IGetSettlementRuleByPeriodRes {
    baseFeeIncrGmvThreshold: string;
    baseFee: string;
    earningsThreshold: string;
    effectHostingInfo: IEffectHostingInfo;
}

export enum BaseFeeInfoTypeEnum {
    FixedPrice = '1',
    PayDay = '2',
}

export enum CommissionInfoTypeEnum {
    No = '1',
    All = '2',
    Increment = '3',
}

export interface IBaseFeeInfo {
    /** 基础服务费收费方式（1-一口价服务费，2-按天扣费） */
    typeValue: BaseFeeInfoTypeEnum;
    typeLabel: string;
    /** 商家日实收门槛（单位元） */
    earningsThreshold: string;
    /** 基础服务费价格（单位元 or 元/天） */
    baseFee: string;
    /** 定金（单位元） */
    deposit: string;
}
export interface ICommissionInfo {
    /** 抽佣方式（1-不抽佣，2-全额抽佣，3-增量抽佣） */
    typeValue: CommissionInfoTypeEnum;
    typeLabel: string;
    /** 抽佣区间左值（单位元） */
    intervalBegin: string;
    /** 抽佣区间右值（单位元） */
    intervalEnd: string;
    /** 抽佣比例 */
    rate: string;
}
export interface IEffectHostingInfo {
    /** 基础服务费相关信息 */
    baseFeeInfo: IBaseFeeInfo;
    /** 抽佣信息 */
    commissionInfo: ICommissionInfo;
}

export interface IEffectHostingInfoSignFormProps {
    info: IEffectHostingInfo;
    effectFormRef: any;
    coopMode: number;
}

export interface IEffectHostingInfoSignFormRate {
    intervalBegin: string;
    intervalEnd: string;
    rate: string;
}

export interface IEffectHostingInfoSignFormValue {
    baseFeeInfo: {
        typeValue: BaseFeeInfoTypeEnum;
        earningsThreshold: string;
        baseFee: string;
        deposit: string;
        typeLabel: string;
    };
    commissionInfo: {
        typeValue: CommissionInfoTypeEnum;
        typeLabel: string;
        intervalList: IEffectHostingInfoSignFormRate[];
    };
}

export enum AcctLoginTypeenums {
    /// 服务商
    PROVIDER = 1,
    /// 客服
    CUSTOMER_SERVICE = 2,
    /// 创作者
    CREATOR = 3,
    /// 外部客服
    OUT_CUSTOMER_SERVICE = 4,
}
